import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BulletinCategory } from './types';

interface CategoryFrequencyProps {
  category: Pick<
    BulletinCategory,
    | 'refresh_day'
    | 'refresh_frequency'
    | 'refresh_type'
    | 'next_update'
    | 'path'
  >;
}

function capitalize(text: string) {
  if (text.length > 2) {
    return text[0].toLocaleUpperCase() + text.slice(1).toLocaleLowerCase();
  }
  if (text.length === 1) {
    return text[0].toLocaleUpperCase();
  }
  return text;
}

function CategoryFrequency({ category }: CategoryFrequencyProps) {
  function getContent() {
    switch (category.refresh_type) {
      case 'DAILY':
        return 'Updated daily';
      case 'WEEKLY':
        return (
          <>
            Updated every {capitalize(category.refresh_day)}
            <span
              data-tip={`Next update on ${category.next_update}`}
              data-for={`category-freq-${category.path}`}
              className="icon-info-circle"
              style={{ color: 'inherit' }}
            />
            <ReactTooltip
              id={`category-freq-${category.path}`}
              place="top"
              type="dark"
              effect="solid"
              className="tooltip"
              role="tooltip"
            />
          </>
        );
      default:
        return (
          <>
            Updated every {category.refresh_frequency} days
            <span
              data-tip={`Next update on ${category.next_update}`}
              data-for={`category-freq-${category.path}`}
              className="icon-info-circle"
              style={{ color: 'inherit' }}
            />
            <ReactTooltip
              id={`category-freq-${category.path}`}
              place="top"
              type="dark"
              effect="solid"
              className="tooltip"
              role="tooltip"
            />
          </>
        );
    }
  }

  return (
    <span
      style={{
        fontWeight: 400,
        fontSize: '0.7rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {getContent()}
    </span>
  );
}

export default CategoryFrequency;
